export enum PrepaidSharingPricePlanTabs {
  TripStart = 'trip-start',
  TripMinutesBeforeFinish = 'minutes-before-trip-finish',
  TripFinish = 'trip-finish',
  ExitingRideAllowArea = 'exiting-ride-allow-area',
  EnteringRideAllowArea = 'entering-ride-allow-area',
  Translations = 'translations',
}

export type PrepaidSharingPricePlanTab = typeof PrepaidSharingPricePlanTabs[keyof typeof PrepaidSharingPricePlanTabs];
